/**
 * Whether a value counts as "no answer" for survey display, skip, and branch logic.
 *
 * Treats as blank: null/undefined, whitespace-only, a lone hyphen-minus (U+002D),
 * or only whitespace around a single hyphen (e.g. "-", " - ", "  -  ").
 *
 * Does not treat hyphens inside real responses as blank
 * (e.g. "strong follow-through - especially under pressure").
 */
export function isBlankAnswerForSurveyDisplayLogic(value: unknown): boolean {
  if (value === undefined || value === null) {
    return true;
  }
  const s = String(value).trim();
  if (s.length === 0) {
    return true;
  }
  return /^[\s\u00A0]*-[\s\u00A0]*$/.test(s);
}

export function hasMeaningfulAnswerForSurveyDisplayLogic(value: unknown): boolean {
  return !isBlankAnswerForSurveyDisplayLogic(value);
}
